import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/webhookStyles/webhookStyle.module.scss";
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import { useWebhookStore } from '../../../store/webhookStore';
import { configuredWebhookData } from '../../../models/axiosModel';

interface ConfiguredWebhookTableProps {
    getWebhookOrganizationListApi:  () => Promise<void>,
} 

const ConfiguredWebhookTable: React.FC<ConfiguredWebhookTableProps> = (props) => {

    const { getWebhookOrganizationListApi } = props;

    const configuredWebhookData = useWebhookStore((state) => state.configuredWebhookData); 

    useEffect(() => {
        getWebhookOrganizationListApi();
    }, [])

    return (
        <Grid container>
            <Grid item className={globalStyles.fullwidth}>
                <Grid container gap={"10px"} direction={"column"}>
                    <Grid item>
                        <Typography className={styles.configuredWebhookTitle}>Configured Webhook</Typography>
                    </Grid>
                    <Grid item className={globalStyles.fullwidth}>
                        <TableContainer className={`${styles.webhookTableContainer}`} sx={{ maxHeight: `350px !important` }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Company Name</TableCell>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>URL</TableCell>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Webhook Desciption</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {configuredWebhookData && configuredWebhookData?.length > 0 ? 
                                        configuredWebhookData?.map((webhook: configuredWebhookData, ind: number) => {
                                            return (
                                                <TableRow key={ind} className={dashboardStyles.cellRow}>    
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{webhook?.webhook_external?.webhook_external_company_name || "-"}</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{webhook?.webhook_organization_full_path || "-"}</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{webhook?.webhook_external?.webhook_external_description || "-"}</TableCell>
                                                </TableRow>
                                            );
                                        })
                                        : 
                                        <TableRow className={dashboardStyles.cellRow}>
                                            <TableCell colSpan={12} className={`${globalStyles.textCenter}`}>
                                                No Data Available
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ConfiguredWebhookTable
